<template functional>
  <div class="btn-group-toggle flex-column w-100">
    <label
      class="btn btn-light text-left w-100 mb-1 d-flex align-items-center"
      v-for="option in props.options"
      :key="option.type"
      :class="{ active: props.value === option.type }"
    >
      <input
        type="radio"
        name="framing"
        :id="`framing-${option.type}`"
        autocomplete="off"
        :checked="props.value === option.type"
        @change="listeners.input($event.target.value)"
        :value="option.type"
      />
      <i
        class="fa mr-1"
        :class="props.value === option.type ? 'fa-check-square' : 'fa-square-o'"
      ></i>
      <small>{{ option.description }}</small>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'ImageFraming',
    functional: true,
    props: {
      value: String,
      options: {
        type: Array,
        default: () => [
          {
            name: 'Cortar' ,
            type: 'cover',
            description: 'Preencher o quadro com a imagem.'
          },
          {
            name: 'Encaixar',
            type: 'contain',
            description: 'Encaixar a imagem dentro do quadro.'
          }
        ]
      }
    }
  }
</script>